import { render } from "./DashboardCharts.vue?vue&type=template&id=db3e6fe4&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"

import "./DashboardCharts.vue?vue&type=style&index=0&id=db3e6fe4&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3e6fe4"]])

export default __exports__